import { render } from "./PestIcon.vue?vue&type=template&id=398dd414"
import script from "./PestIcon.vue?vue&type=script&lang=js"
export * from "./PestIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__